module.exports = __webpack_public_path__ + "img/madeby.ff12cd61.svg";